export default __webpack_public_path__ + "static/media/q.d66b513e.svg";